// Shimmering placeholder used while data loads, so screens never flash empty.
export const Skeleton = ({ className = "", style }) => (
  <div className={`skeleton-shimmer rounded-md ${className}`} style={style} aria-hidden="true" />
);

export default Skeleton;
